// extracted by mini-css-extract-plugin
module.exports = {"box":"breadCrumb_box__3gv5k","item":"breadCrumb_item__3ngfv","active":"breadCrumb_active__3D8vk"};